import type { ReactNode } from 'react';
import { Icon } from '../icons/Icon.js';
import type { IconName } from '../icons/registry.js';

export function Toolbar({ children }: { children: ReactNode }) {
  return <div className="toolbar">{children}</div>;
}

/** 带前缀图标的输入框 */
export function PrefixInput({
  icon, placeholder, value, onChange, width,
}: {
  icon: IconName;
  placeholder?: string;
  value: string;
  onChange: (v: string) => void;
  width?: number | string;
}) {
  return (
    <div className="input-prefix" style={width ? { width } : undefined}>
      <Icon name={icon} size={16} />
      <input
        className="input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

/** 带 chevron 的下拉 */
export function NativeSelect<V extends string>({
  value, onChange, options, width,
}: {
  value: V;
  onChange: (v: V) => void;
  options: ReadonlyArray<{ value: V; label: string }>;
  width?: number | string;
}) {
  return (
    <div className="select-wrap" style={width ? { width } : undefined}>
      <select
        className="select"
        value={value}
        onChange={(e) => onChange(e.target.value as V)}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <Icon name="chevron" size={16} />
    </div>
  );
}
